import { accessContentTasks } from '@/permissions/contentTasks';
import { FEATURE_FLAGS } from '@teamworksdev/influencer/core';
import type { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
	{
		path: '/content-tasks',
		name: 'ContentTasks',
		component: () => import('@/views/ContentTasks.vue'),
		meta: {
			requiresAuth: true,
			layout: 'LayoutAuthenticated',
			title: 'pageContentTasks.metaTitle',
			permissionRule: accessContentTasks,
			requiredLDFlags: [FEATURE_FLAGS.CONTENT_TASKS],
		},
	},
	{
		path: '/content-tasks/:taskUuid',
		redirect: (to) => ({ name: 'ContentTasks', params: {}, query: { ...to.query, taskUuid: to.params.taskUuid } }),
	},
];

export default routes;
